const texts = {
    totalCounterSAP: totalCounter => `disponible prévisionnel sur un total de ${totalCounter} €`,
    aucunTitre: "Vous n'avez pas encore de CESU.",
}

export default texts
